import React from "react";
import { Plus, Star } from "lucide-react";

export const ProductCard = ({ product, onAdd, onQuickView, index = 0 }) => {
  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group flex flex-col"
    >
      {/* Image */}
      <div className="relative overflow-hidden bg-[#E2DACF] aspect-[4/5] cursor-pointer">
        <img
          data-testid={`product-image-${product.id}`}
          src={product.image}
          alt={product.title}
          onClick={() => onQuickView(product)}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />

        {/* Quick add */}
        <button
          data-testid={`product-quick-add-${product.id}`}
          onClick={() => onAdd(product)}
          className="absolute bottom-0 left-0 w-full bg-[#2B3A2F] text-[#F7F5F0] py-3.5 text-xs tracking-[0.18em] uppercase font-medium translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out flex items-center justify-center gap-2 hover:bg-[#1E2922]"
        >
          <Plus className="w-3.5 h-3.5" /> Add to Basket
        </button>

        <span className="absolute top-3 left-3 bg-[#F7F5F0]/90 backdrop-blur-sm text-[#2B3A2F] text-[10px] tracking-[0.15em] uppercase font-semibold px-2.5 py-1">
          One of a Kind
        </span>
      </div>

      {/* Text */}
      <div className="pt-4 space-y-1.5">
        <p className="text-[10px] tracking-[0.2em] uppercase font-semibold text-[#5C6B5F]">
          {product.category}
        </p>
        <h3
          onClick={() => onQuickView(product)}
          className="font-cormorant text-xl font-normal leading-tight cursor-pointer hover:text-[#C47D65] transition-colors"
        >
          {product.title}
        </h3>
        <div className="flex items-center justify-between pt-1">
          <span
            data-testid={`product-price-${product.id}`}
            className="text-base font-medium tracking-tight"
          >
            ₹{product.price.toLocaleString("en-IN")}
          </span>
          <span className="flex items-center gap-1 text-xs text-[#5C6B5F]">
            <Star className="w-3.5 h-3.5 fill-[#C47D65] text-[#C47D65]" />
            {product.rating}{" "}
            <span className="text-[#5C6B5F]/60">({product.reviewsCount})</span>
          </span>
        </div>
      </div>
    </div>
  );
};
